import { render, staticRenderFns } from "./QnIndustry.vue?vue&type=template&id=9a03c9ea&scoped=true&"
import script from "./QnIndustry.vue?vue&type=script&lang=js&"
export * from "./QnIndustry.vue?vue&type=script&lang=js&"
import style0 from "./QnIndustry.vue?vue&type=style&index=0&id=9a03c9ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a03c9ea",
  null
  
)

export default component.exports